const FOOTER_LINKS = [
  { id: "profile", label: "影片档案" },
  { id: "plot", label: "剧情介绍" },
  { id: "characters", label: "角色与演员表" },
  { id: "commentary", label: "分幕解说" },
  { id: "themes", label: "主题解析" },
  { id: "reviews", label: "影迷短评" },
  { id: "faq", label: "常见问题" },
];

export default function SiteFooter() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-quill-pen-fill" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold">漂亮的小姨子</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/85 max-w-md">
              本站围绕《漂亮的小姨子》整理影片档案、剧情介绍、角色关系、演员表与分幕解说，
              并对主题与观众观点做了分类归档，方便你按需核对不同方向的信息。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["家庭伦理片", "剧情介绍", "角色关系", "演员表", "分幕解说"].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full bg-primary-900/70 text-primary-100 text-xs font-label"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-base font-semibold text-background-50">本页内容导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5">
              {FOOTER_LINKS.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(event) => {
                      event.preventDefault();
                      scrollTo(link.id);
                    }}
                    className="inline-flex items-center gap-1.5 text-sm text-background-200/85 hover:text-primary-200 transition-colors"
                  >
                    <i className="ri-arrow-right-s-line" aria-hidden="true" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-base font-semibold text-background-50">资料说明</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200/85">
              <li className="flex gap-2">
                <i className="ri-information-line mt-0.5 text-primary-300" aria-hidden="true" />
                影片信息与演员表以本站整理为准，可能存在版本差异。
              </li>
              <li className="flex gap-2">
                <i className="ri-chat-1-line mt-0.5 text-primary-300" aria-hidden="true" />
                短评与解说为观众观点整理，不代表统一评价。
              </li>
              <li className="flex gap-2">
                <i className="ri-refresh-line mt-0.5 text-primary-300" aria-hidden="true" />
                内容会随资料补充持续更新。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300/70">
            © {new Date().getFullYear()} 漂亮的小姨子 · 影视资料整理页
          </p>
          <p className="text-xs text-background-300/70">
            本站仅用于影视信息与剧情讨论，内容以公开资料整理为准。
          </p>
        </div>
      </div>
    </footer>
  );
}